import { render, staticRenderFns } from "./detlawbrinfo.vue?vue&type=template&id=08c56cc8&scoped=true&"
import script from "./detlawbrinfo.vue?vue&type=script&lang=js&"
export * from "./detlawbrinfo.vue?vue&type=script&lang=js&"
import style0 from "./detlawbrinfo.vue?vue&type=style&index=0&id=08c56cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c56cc8",
  null
  
)

export default component.exports